import { makeActionCreator } from '../../../../utilities'
import { VentricularAssistDeviceConstants } from './ventricularAssistDevice.constants'

export const setDate = makeActionCreator(VentricularAssistDeviceConstants.SET_DATE, 'date')
export const setTime = makeActionCreator(VentricularAssistDeviceConstants.SET_TIME, 'time')
export const setDateTime = makeActionCreator(VentricularAssistDeviceConstants.SET_DATE_TIME, 'time', 'date')
export const setPTA = makeActionCreator(VentricularAssistDeviceConstants.SET_PTA, 'pta')
export const setAssessedBy = makeActionCreator(VentricularAssistDeviceConstants.SET_ASSESSED_BY, 'assessedBy')
export const setRolePerforming = makeActionCreator(
  VentricularAssistDeviceConstants.SET_ROLE_PERFORMING,
  'rolePerforming'
)
export const setRolePerformingPNNV = makeActionCreator(
  VentricularAssistDeviceConstants.SET_ROLE_PERFORMING_PNNV,
  'rolePerformingPNNV'
)
export const setSuccessfulAttempt = makeActionCreator(
  VentricularAssistDeviceConstants.SET_SUCCESSFUL_ATTEMPT,
  'successfulAttempt'
)
export const setAddToTimeLine = makeActionCreator(VentricularAssistDeviceConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setVentricularAssistDeviceType = makeActionCreator(
  VentricularAssistDeviceConstants.SET_VENTRICULAR_ASSIST_DEVICE_TYPE,
  'ventricularAssistDeviceType'
)
export const setIndication = makeActionCreator(VentricularAssistDeviceConstants.SET_INDICATION, 'indication')
export const setPulsatilityIndex = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PULSATILITY_INDEX,
  'pulsatilityIndex'
)
export const setAuscultated = makeActionCreator(VentricularAssistDeviceConstants.SET_AUSCULTATED, 'auscultated')
export const setMakeModelVad = makeActionCreator(VentricularAssistDeviceConstants.SET_MAKE_MODEL_VAD, 'makeModelVad')
export const setMakeModelImpella = makeActionCreator(
  VentricularAssistDeviceConstants.SET_MAKE_MODEL_IMPELLA,
  'makeModelImpella'
)
export const setPLevel = makeActionCreator(VentricularAssistDeviceConstants.SET_P_LEVEL, 'pLevel')
export const setSpeedRpms = makeActionCreator(VentricularAssistDeviceConstants.SET_SPEED_RPMS, 'speedRpms')
export const setFlowType = makeActionCreator(VentricularAssistDeviceConstants.SET_FLOW_TYPE, 'flowType')
export const setControllerNumber = makeActionCreator(
  VentricularAssistDeviceConstants.SET_CONTROLLER_NUMBER,
  'controllerNumber'
)
export const setMotorCurrentMa = makeActionCreator(
  VentricularAssistDeviceConstants.SET_MOTOR_CURRENT_MA,
  'motorCurrentMa'
)
export const setMotorCurrentWaveformCharacteristics = makeActionCreator(
  VentricularAssistDeviceConstants.SET_MOTOR_CURRENT_WAVE_FORM_CHARACTERISTICS,
  'motorCurrentWaveformCharacteristics'
)
export const setPlacementSignalMmHg = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PLACEMENT_SIGNAL_MMHG,
  'placementSignalMmHg'
)
export const setPlacementSignalWaveformCharacteristics = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS,
  'placementSignalWaveformCharacteristics'
)
export const setPlacementConfirmedBy = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PLACEMENT_CONFIRMED_BY,
  'placementConfirmedBy'
)
export const setCatheterSize = makeActionCreator(VentricularAssistDeviceConstants.SET_CATHETER_SIZE, 'catheterSize')
export const setCatheterDepthCm = makeActionCreator(
  VentricularAssistDeviceConstants.SET_CATHETER_DEPTH_CM,
  'catheterDepthCm'
)
export const setCatheterSerialNumber = makeActionCreator(
  VentricularAssistDeviceConstants.SET_CATHETER_SERIAL_NUMBER,
  'catheterSerialNumber'
)
export const setInsertLocation = makeActionCreator(
  VentricularAssistDeviceConstants.SET_INSERT_LOCATION,
  'insertLocation'
)
export const setPlacementLocation = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PLACEMENT_LOCATION,
  'placementLocation'
)
export const setSiteAssessment = makeActionCreator(
  VentricularAssistDeviceConstants.SET_SITE_ASSESSMENT,
  'siteAssessment'
)
export const setLegImmobilized = makeActionCreator(
  VentricularAssistDeviceConstants.SET_LEG_IMMOBILIZED,
  'legImmobilized'
)
export const setCatheterSuturedInPlace = makeActionCreator(
  VentricularAssistDeviceConstants.SET_CATHETER_SUTURED_IN_PLACE,
  'catheterSuturedInPlace'
)
export const setDressingCondition = makeActionCreator(
  VentricularAssistDeviceConstants.SET_DRESSING_CONDITION,
  'dressingCondition'
)
export const setPulsesDistalToInsertionSite = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PULSES_DISTAL_TO_INSERTION_SITE,
  'pulsesDistalToInsertionSite'
)
export const setAnchoringRingLocked = makeActionCreator(
  VentricularAssistDeviceConstants.SET_ANCHORING_RING_LOCKED,
  'anchoringRingLocked'
)
export const setHeadOfBedAt30Degrees = makeActionCreator(
  VentricularAssistDeviceConstants.SET_HEAD_OF_BED_AT_30_DEGREES,
  'headOfBedAt30Degrees'
)
export const setAnticoagulation = makeActionCreator(
  VentricularAssistDeviceConstants.SET_ANTICOAGULATION,
  'anticoagulation'
)
export const setAntidysrhythmia = makeActionCreator(
  VentricularAssistDeviceConstants.SET_ANTIDYSRHYTHMIA,
  'antidysrhythmia'
)
export const setPurgeSolutionDextrosePercent = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PURGE_SOLUTION_DEXTROSE_PERCENT,
  'purgeSolutionDextrosePercent'
)
export const setPurgeSolutionHeparinIuMl = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PURGE_SOLUTION_HEPARIN_IU_ML,
  'purgeSolutionHeparinIuMl'
)
export const setPurgeSolutionFlowMlHr = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PURGE_SOLUTION_FLOW_ML_HR,
  'purgeSolutionFlowMlHr'
)
export const setPressureBagUsed = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PRESSURE_BAG_USED,
  'pressureBagUsed'
)
export const setPurgePressureMmHg = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PURGE_PRESSURE_MMHG,
  'purgePressureMmHg'
)
export const setFlowLMin = makeActionCreator(VentricularAssistDeviceConstants.SET_FLOW_L_MIN, 'flowLMin')
export const setPowerWatts = makeActionCreator(VentricularAssistDeviceConstants.SET_POWER_WATTS, 'powerWatts')
export const setPowerType = makeActionCreator(VentricularAssistDeviceConstants.SET_POWER_TYPE, 'powerType')
export const setBatteryStatus = makeActionCreator(VentricularAssistDeviceConstants.SET_BATTERY_STATUS, 'batteryStatus')
export const setBackupOptions = makeActionCreator(VentricularAssistDeviceConstants.SET_BACKUP_OPTIONS, 'backupOptions')
export const setAlarms = makeActionCreator(VentricularAssistDeviceConstants.SET_ALARMS, 'alarms')
export const setVadCoordinatorNotification = makeActionCreator(
  VentricularAssistDeviceConstants.SET_VAD_COORDINATOR_NOTIFICATION,
  'vadCoordinatorNotification'
)
export const setInflowCannulaSiteAssessment = makeActionCreator(
  VentricularAssistDeviceConstants.SET_INFLOW_CANNULA_SITE_ASSESSMENT,
  'inflowCannulaSiteAssessment'
)
export const setOutflowCannulaSiteAssessment = makeActionCreator(
  VentricularAssistDeviceConstants.SET_OUTFLOW_CANNULA_SITE_ASSESSMENT,
  'outflowCannulaSiteAssessment'
)
export const setHideVadFields = makeActionCreator(
  VentricularAssistDeviceConstants.SET_HIDE_VAD_FIELDS,
  '_hideVadFields'
)
export const setHideImpellaFields = makeActionCreator(
  VentricularAssistDeviceConstants.SET_HIDE_IMPELLA_FIELDS,
  '_hideImpellaFields'
)
export const onSelectVentricularAssistDeviceProcedure = makeActionCreator(
  VentricularAssistDeviceConstants.ON_SELECT_VENTRICULAR_ASSIST_DEVICE
)
export const setUpdateInputRows = makeActionCreator(
  VentricularAssistDeviceConstants.SET_UPDATE_INPUT_ROWS,
  'updateInputRows'
)
export const setState = makeActionCreator(VentricularAssistDeviceConstants.SET_STATE, 'ventricularAssistDeviceState')
export const saveVentricularAssistDevice = makeActionCreator(
  VentricularAssistDeviceConstants.SAVE_VENTRICULAR_ASSIST_DEVICE
)
export const clearFields = makeActionCreator(VentricularAssistDeviceConstants.CLEAR_FIELDS)
export const resetState = makeActionCreator(VentricularAssistDeviceConstants.RESET_STATE)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  VentricularAssistDeviceConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
